module.exports = __webpack_public_path__ + "img/site_bg.9686cb3d.jpg";